module.exports = "//static.hsappstatic.net/salesImages/static-1.403/crm-images/call_activity_types.svg"